// Must stay the first import: it patches the console before any other module can log.
import '@/utils/ConsoleGuard'
import { Application } from '@/application/Application'
// Side-effect import: seeds the shared Facade singleton with the game defaults.
import './Facade'
import { configureOperatorConfig, setModulesConfig } from '@dragonframework/modules'
import ModulesConfig from '@/modulesConfig'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { configRepo } from './repository'
import ExternalUiAdapter from './ui/ExternalUiAdapter'
import { mountUi, unmountUi } from '@dragonframework/slot-ui'
import { buildAssetUrl, getResolvedAssetsBase } from '@/utils/AssetsUrlUtil'
import { getGameEnginePath } from '@/utils/GameEnginePath'
import '@/managers/TournamentManager'

dayjs.extend(duration)

declare global {
    interface Window {
        __cashCongBootstrapped?: boolean
        gameEnginePath?: string
    }
}

window.onload = async function () {
    if (window.__cashCongBootstrapped) {
        console.warn('[Bootstrap] Already initialized, skip duplicated startup')
        return
    }

    window.__cashCongBootstrapped = true

    // Set the operator config source here directly, without using a .env file.
    // This is always remote now, even in local/dev.
    const USE_REMOTE_OPERATOR_CONFIG = false
    const remoteOperatorConfigBase = getGameEnginePath() || 'https://staging-games.dragongaming.com'
    const REMOTE_OPERATOR_CONFIG_URL = `${remoteOperatorConfigBase}/games/slots/config/operatorConfig.js`
    const LOCAL_OPERATOR_CONFIG_URL = buildAssetUrl('/assets/js/operatorConfig.js')
    const operatorConfigUrl = USE_REMOTE_OPERATOR_CONFIG ? REMOTE_OPERATOR_CONFIG_URL : LOCAL_OPERATOR_CONFIG_URL

    await configureOperatorConfig(null, operatorConfigUrl)

    // Inject game-specific modules config into the shared framework singleton
    setModulesConfig(ModulesConfig)

    // Initialize PixiJS game
    new Application()

    // External package UI only
    // slot-ui ships its own /assets/... paths; hand it the same base the Pixi loaders use.
    mountUi(document.body, { assetsBase: getResolvedAssetsBase() })
    const adapter = new ExternalUiAdapter()
    adapter.start()
    ;(window as unknown as { __cashCongExternalUiAdapter?: ExternalUiAdapter }).__cashCongExternalUiAdapter = adapter

    window.addEventListener('beforeunload', () => {
        adapter.stop()
        unmountUi()
    })

    configRepo.getState().load()
}
